export default "__VITE_ASSET__BMeUEnbx__"